<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      <vx-card title="">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-1"><datepicker :format="format" v-model="baslangic"></datepicker></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><datepicker :format="format" v-model="bitis"></datepicker></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><vs-button color="success" @click="satisListesi()" type="filled">Listele</vs-button></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><span v-if="data.length>0"> 
              <download-excel 
	class   = "btn btn-default"
	:data   = "data"
	name    = "karlilik.xls">

	Excel İndir

</download-excel></span></div>
        </div>

          
       
  

      </vx-card>

      <vs-table :data="data">
        <template slot="thead">
          
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Tutar</vs-th>
          <vs-th>Miktar</vs-th>
          <vs-th>Maliyet</vs-th>
          <vs-th>Kargo</vs-th>
          <vs-th>Komisyon</vs-th>
          <vs-th>Net Kar</vs-th>

         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].stokKodu }}
              </vs-td>
              
              <vs-td>
               {{ (data[indextr].tutar) }}
              </vs-td>
           <vs-td>
               {{ data[indextr].miktar }}
              </vs-td>
               <vs-td>
               {{ formatla(data[indextr].maliyet) }}
              </vs-td>
               <vs-td>
               {{ formatla(data[indextr].kargo) }}
              </vs-td>
               <vs-td>
               {{ formatla((data[indextr].tutarHesap*(data[indextr].komisyon/100))) }}
              </vs-td>
               <vs-td>
                 {{formatla(data[indextr].tutarHesap-data[indextr].maliyet-data[indextr].kargo-(data[indextr].tutarHesap*(data[indextr].komisyon/100)))}}
             
              </vs-td>
            </vs-tr>
            <vs-tr>
             
              <vs-td></vs-td>
              <vs-td>{{tutarTopla()}}</vs-td>
              <vs-td></vs-td>
              <vs-td>{{maliyetTopla()}}</vs-td>
              <vs-td>{{kargoTopla()}}</vs-td>
              <vs-td>{{komisyonTopla()}}</vs-td>
              <vs-td>{{karlilik()}}</vs-td>
            </vs-tr>
          </template>

      </vs-table>

    </div>

    
  </div>




  </div>


  
</template>



<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import state from '../../store/state'
import Store from '../../store/store'
export default{
  data () {
    return {
      format: "yyyy-MM-dd",
      data:[],
      sipariseGoreUrunListesi:[],
      baslangic: '',
      formattedDate: '',
      formattedDate1: '',
      bitis: '',
      program: {id: 0, label: 'Pazaryeri'},
      check3: '',
      formatOptions: [
        {label: "Tsoft", id:"Tsoft"},
        {label: "Ticimax", id:"Ticimax"},
        {label: "Trendyol", id:"Trendyol"},
        {label: "Hepsiburada", id:"Hepsiburada"},
        {label: "N11", id:"N11"},
      ],
    }
  },methods:{
       getNow: function() {
                    const today = new Date();
                    const date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    return dateTime;
                },
                formatla(d) {
                  var g=d.toFixed(2);
                  return g.replace(".",",")
                },
     miktarTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseInt(element.adet)
      });
      return sayi
     // this.toplam=parseInt(this.toplam)+parseInt(d)
     // return this.toplam
      //console.log(this.toplam)
    },
    tutarTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat(element.tutar)
      });
      return Math.round(sayi*100)/100
         
    },
    maliyetTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat(element.maliyet)
      });
      return Math.round(sayi*100)/100
         
    },
    kargoTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat(element.kargo)
      });
      return Math.round(sayi*100)/100
         
    },
    komisyonTopla() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat((element.tutar*(element.komisyon/100)))
      });
      return Math.round(sayi*100)/100
         
    },
    karlilik() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseFloat(element.tutar-element.maliyet-element.kargo-(element.tutar*(element.komisyon/100)))
      });
      return Math.round(sayi*100)/100
         
    },
    ciktiAl(kargoAdi) {
          var vm = this

        const soap = require('soap')
        const url = state.sistemAddress
    
		var d = new Date(vm.baslangic);
		vm.formattedDate =  d.getUTCFullYear()+"-"+(d.getUTCMonth()+1)+"-"+d.getUTCDate();

    	var d1 = new Date(vm.bitis);
		vm.formattedDate1 =  d1.getUTCFullYear()+"-"+(d1.getUTCMonth()+1)+"-"+d1.getUTCDate(); 
     // console.log(vm.formattedDate)
      const args = {program:this.program.label,baslik:'kargoGonderimListesi',tarih1:vm.formattedDate,tarih2:vm.formattedDate1,token:Store.state.tokenId,kullaniciId:kargoAdi,siparisNo:''}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorguRapor(args, function(err, result){
        if (result.standartSorguRaporResult=='-1') {
          Store.dispatch('logout')
        }
        vm.veriler=JSON.parse(result.standartSorguRaporResult)
        //console.log(vm.veriler)
        vm.sipariseGoreUrunListesi=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
       
      
      
        
      })
      })

    },
    yazdir() {
      this.$htmlToPaper('printMe')
    },
satisListesi() {
         var vm = this

        const soap = require('soap')
        const url = state.sistemAddress
    
		var d = new Date(vm.baslangic);
		vm.formattedDate =  d.getUTCFullYear()+"-"+(d.getUTCMonth()+1)+"-"+d.getUTCDate();

    	var d1 = new Date(vm.bitis);
		vm.formattedDate1 =  d1.getUTCFullYear()+"-"+(d1.getUTCMonth()+1)+"-"+d1.getUTCDate(); 
     // console.log(vm.formattedDate)
      const args = {program:this.program.label,baslik:'gunlukKazancRaporu',tarih1:vm.formattedDate,tarih2:vm.formattedDate1,token:Store.state.tokenId,kullaniciId:'',siparisNo:''}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorguRapor(args, function(err, result){
        if (result.standartSorguRaporResult=='-1') {
          Store.dispatch('logout')
        }
        vm.veriler=JSON.parse(result.standartSorguRaporResult)
        //console.log(vm.veriler)
        vm.data=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
  
      
      
        
      })
      })
    },
  },
   components: {
    'v-select': vSelect,
    Datepicker
  }
}
</script>
